import * as langaugeTanslatorTypes from "../../types/admin/languageTranslator";

//Get Language Translator
export const getLanguageTranslatorReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case langaugeTanslatorTypes.GET_LANGUAGE_TRANSLATORS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case langaugeTanslatorTypes.GET_LANGUAGE_TRANSLATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        translations: payload,
        error: "",
      };
    case langaugeTanslatorTypes.GET_LANGUAGE_TRANSLATORS_FAIL:
      return {
        ...state,
        loading: false,
        translations: [],
        error: payload,
      };
    default:
      return state;
  }
};
